{
 "title": {
  "x": 342,
  "y": 342,
  "w": 264,
  "h": 49,
  "lane": {
   "x": 300,
   "y": 330,
   "w": 340,
   "h": 70
  }
 },
 "tab.friends": {
  "x": 221,
  "y": 487,
  "w": 144,
  "h": 41,
  "lane": {
   "x": 180,
   "y": 480,
   "w": 220,
   "h": 60
  }
 },
 "tab.requests": {
  "x": 576,
  "y": 480,
  "w": 214,
  "h": 57,
  "lane": {
   "x": 530,
   "y": 480,
   "w": 260,
   "h": 60
  }
 },
 "badge": {
  "x": 771,
  "y": 449,
  "w": 36,
  "h": 51,
  "lane": {
   "x": 770,
   "y": 446,
   "w": 60,
   "h": 54
  }
 },
 "r1.name": {
  "x": 240,
  "y": 640,
  "w": 84,
  "h": 60,
  "lane": {
   "x": 240,
   "y": 640,
   "w": 320,
   "h": 60
  }
 },
 "r1.status": {
  "x": 241,
  "y": 692,
  "w": 319,
  "h": 48,
  "lane": {
   "x": 240,
   "y": 692,
   "w": 320,
   "h": 48
  }
 },
 "r1.btn": {
  "x": 666,
  "y": 661,
  "w": 103,
  "h": 39,
  "lane": {
   "x": 620,
   "y": 656,
   "w": 190,
   "h": 56
  }
 },
 "r2.name": {
  "x": 240,
  "y": 761,
  "w": 87,
  "h": 59,
  "lane": {
   "x": 240,
   "y": 760,
   "w": 320,
   "h": 60
  }
 },
 "r2.status": {
  "x": 242,
  "y": 815,
  "w": 203,
  "h": 44,
  "lane": {
   "x": 240,
   "y": 812,
   "w": 320,
   "h": 48
  }
 },
 "r2.btn": {
  "x": 666,
  "y": 782,
  "w": 103,
  "h": 40,
  "lane": {
   "x": 620,
   "y": 776,
   "w": 190,
   "h": 56
  }
 },
 "r3.name": {
  "x": 240,
  "y": 882,
  "w": 99,
  "h": 58,
  "lane": {
   "x": 240,
   "y": 880,
   "w": 320,
   "h": 60
  }
 },
 "r3.status": {
  "x": 243,
  "y": 932,
  "w": 317,
  "h": 48,
  "lane": {
   "x": 240,
   "y": 932,
   "w": 320,
   "h": 48
  }
 },
 "r3.btn": {
  "x": 666,
  "y": 902,
  "w": 103,
  "h": 39,
  "lane": {
   "x": 620,
   "y": 896,
   "w": 190,
   "h": 56
  }
 },
 "r4.name": {
  "x": 240,
  "y": 1002,
  "w": 86,
  "h": 58,
  "lane": {
   "x": 240,
   "y": 1000,
   "w": 320,
   "h": 60
  }
 },
 "r4.status": {
  "x": 240,
  "y": 1052,
  "w": 320,
  "h": 48,
  "lane": {
   "x": 240,
   "y": 1052,
   "w": 320,
   "h": 48
  }
 },
 "r4.btn": {
  "x": 666,
  "y": 1022,
  "w": 103,
  "h": 39,
  "lane": {
   "x": 620,
   "y": 1016,
   "w": 190,
   "h": 56
  }
 },
 "r5.name": {
  "x": 241,
  "y": 1120,
  "w": 86,
  "h": 60,
  "lane": {
   "x": 240,
   "y": 1120,
   "w": 320,
   "h": 60
  }
 },
 "r5.status": {
  "x": 243,
  "y": 1172,
  "w": 137,
  "h": 39,
  "lane": {
   "x": 240,
   "y": 1172,
   "w": 320,
   "h": 48
  }
 },
 "r5.btn": {
  "x": 666,
  "y": 1141,
  "w": 103,
  "h": 39,
  "lane": {
   "x": 620,
   "y": 1136,
   "w": 190,
   "h": 56
  }
 },
 "cta": {
  "x": 318,
  "y": 1294,
  "w": 311,
  "h": 39,
  "lane": {
   "x": 260,
   "y": 1282,
   "w": 420,
   "h": 64
  }
 }
}